
/**
 * Distance mappings for iron, fairway wood and driver tests
 */
import i18n from "@/lib/i18n";

export const getIronDistances = (testId: string): Record<string, string> => {
  // Vérifier si nous sommes dans le niveau 2
  const isLevel2 = window.location.pathname.includes('level2');
  
  if (isLevel2) {
    if (testId === "iron-long") {
      return {
        "D": "130m"
      };
    } else if (testId === "iron-mid") {
      return {
        "D": "80m"
      };
    }
  } else {
    // Level 3 iron tests
    if (testId === "iron-precision") {
      return {
        "IronA": "110m",
        "IronB": "130m",
        "IronC": "150m"
      };
    } else if (testId === "iron-green-attack-100") {
      return {
        "IronGreenAttack100": "100m"
      };
    }
  }
  
  return {};
};

export const getFairwayWoodDistances = (testId: string): Record<string, string> => {
  // Vérifier si nous sommes dans le niveau 2
  const isLevel2 = window.location.pathname.includes('level2');
  
  if (isLevel2) {
    if (testId === "fairwayWood-3") {
      return {
        "D": "180m"
      };
    } else if (testId === "fairwayWood-5") {
      return {
        "D": "160m"
      };
    }
  } else {
    // Level 3
    if (testId === "fairwayWood-precision") {
      return {
        "FairwayWoodA": "170m",
        "FairwayWoodB": "180m",
        "FairwayWoodC": "200m"
      };
    }
  }
  
  return {};
};

export const getDriverDistances = (testId: string): Record<string, string> => {
  // Vérifier si nous sommes dans le niveau 2
  const isLevel2 = window.location.pathname.includes('level2');
  
  if (isLevel2) {
    if (testId === "driver-practice" || testId === "driver-accuracy") {
      return {
        "D": "180m"
      };
    }
  } else {
    // Level 3
    if (testId.startsWith('driver-')) {
      return {
        "DriverA": i18n.t('level3.distances.driverA', { ns: 'training' })
      };
    }
  }
  
  return {};
};
